import React, { createContext, useContext, useState, useEffect } from "react";
import apiService from "../Simplify360Chat/Services/APIService";
import { s360ConfigService } from "../Simplify360Chat/Services/S360Config";

const PrimaryIdentificationContext = createContext(null);

export const PrimaryIdentificationProvider = ({ children }) => {
  const [primaryIdentification, setPrimaryIdentification] = useState(
    sessionStorage.getItem(
      `${s360ConfigService.config.widgetconfigId}-primaryIdentification`
    ) || null
  );
  const updatePrimaryIdentification = (dynamicFormData) => {
    let hasPrimaryIdentification = false;

    if (Array.isArray(dynamicFormData)) {
      for (const block of dynamicFormData) {
        const elements = block?.elements;
        if (!Array.isArray(elements)) continue;

        for (const element of elements) {
          if (element?.properties?.primaryIdentification === true) {
            hasPrimaryIdentification = true;
            break;
          }
        }

        if (hasPrimaryIdentification) break;
      }
    }

    const widgetId = s360ConfigService?.config?.widgetconfigId;
    const sessionKey = `${widgetId}-primaryIdentification`;

    setPrimaryIdentification(hasPrimaryIdentification);
    sessionStorage.setItem(
      sessionKey,
      JSON.stringify(hasPrimaryIdentification)
    );

    return hasPrimaryIdentification;
  };

  useEffect(() => {
    const cached = sessionStorage.getItem(
      `${s360ConfigService.config.widgetconfigId}-primaryIdentification`
    );
    if (cached && cached !== "null") {
      setPrimaryIdentification(cached);
    }
  }, []);

  return (
    <PrimaryIdentificationContext.Provider
      value={{ primaryIdentification, updatePrimaryIdentification }}
    >
      {children}
    </PrimaryIdentificationContext.Provider>
  );
};

export const usePrimaryIdentification = () => {
  const context = useContext(PrimaryIdentificationContext);
  if (!context) {
    throw new Error(
      "usePrimaryIdentification must be used within PrimaryIdentificationProvider"
    );
  }
  return context;
};
